export default {
  merchants: docs => docs.sort( ( d0, d1 ) => 
    ( d0.sample == undefined ? 0 : d0.sample ) - ( d1.sample == undefined ? 0 : d1.sample )
  )
}